import { defineComponent, inject, ref, computed, resolveComponent, openBlock, createBlock, unref } from 'vue';
import { pageKey } from '@drapejs/core';

var script = /*#__PURE__*/defineComponent({
  name: 'storyblok-global-block-container',
  props: {
    block: null
  },

  setup(__props) {
    const props = __props;
    const page = inject(pageKey, ref({}));
    const blocks = computed(() => {
      var _page$value, _page$value$__sb_rels, _page$value$__sb_rels2, _page$value$__sb_rels3;

      if (!props.block.link) {
        return [];
      }

      return (_page$value = page.value) === null || _page$value === void 0 ? void 0 : (_page$value$__sb_rels = _page$value.__sb_rels) === null || _page$value$__sb_rels === void 0 ? void 0 : (_page$value$__sb_rels2 = _page$value$__sb_rels[props.block.link]) === null || _page$value$__sb_rels2 === void 0 ? void 0 : (_page$value$__sb_rels3 = _page$value$__sb_rels2.content) === null || _page$value$__sb_rels3 === void 0 ? void 0 : _page$value$__sb_rels3.blocks;
    });
    return (_ctx, _cache) => {
      const _component_blocks_repeater = resolveComponent("blocks-repeater");

      return openBlock(), createBlock(_component_blocks_repeater, {
        blocks: unref(blocks)
      }, null, 8, ["blocks"]);
    };
  }

});

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Assign InstallableComponent type
  const installable = script; // Attach install function executed by Vue.use()

  installable.install = app => {
    app.component('StoryblokGlobalBlockContainer', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

export { entry_esm as default };
